import { routerMain } from 'constants/routerMain';
import { lazy } from 'react';

// const Page401 = lazy(() => import('components/errors/Page401'));
const Page403 = lazy(() => import('components/errors/Page403'));
const Page404 = lazy(() => import('components/errors/Page404'));
const Page500 = lazy(() => import('components/errors/Page500'));

const PageErrorRouter = [
    {
        path: routerMain.PAGE_403,
        exact: true,
        component: Page403,
    },
    {
        path: routerMain.PAGE_500,
        exact: true,
        component: Page500,
    },
    {
        path: '*',
        exact: true,
        component: Page404,
    },
];
export default PageErrorRouter;
